import JobOpportunityList from './List'
import JobOpportunityEdit from './Edit'
import JobOpportunityCreate from './Create'

const JobOpportunityResource = {
  list: JobOpportunityList,
  edit: JobOpportunityEdit,
  create: JobOpportunityCreate,
}

export default JobOpportunityResource
